import { Flex, Icon, Progress, Text } from '@chakra-ui/react'
import { CheckCircleIcon } from 'lucide-react'
import React from 'react'

export const InProgress: React.FC<{ currentProgress: number }> = ({ currentProgress }) => {

    // MarketCast palette: brand blue while seeding, brand green when complete.
    const getFillColor = (progress: number) => {
        if (progress <= 0) return "marketcast.gray.4";
        if (progress < 100) return "marketcast.primaryCta.1";
        return "marketcast.green.1";
    };

    return (
        <Flex alignItems="center" gap={3}>
            <Progress
                value={currentProgress}
                size="md"
                borderRadius="md"
                flex="1"
                bg="marketcast.gray.5"
                transition="all 0.5s ease-in-out"
                sx={{
                    // Chakra's Progress renders the filled portion as the inner
                    // div; recolor it directly with MarketCast tokens.
                    "& > div:first-of-type": {
                        backgroundColor: getFillColor(currentProgress),
                        transition: "width 0.5s ease-in-out, background-color 0.3s ease-in-out",
                    },
                }}
            />
            <Text fontSize="sm" whiteSpace="nowrap">
                {currentProgress === 100 ? (
                    <Icon as={CheckCircleIcon} boxSize={5} color="marketcast.green.1" />
                ) : (
                    `${currentProgress}%`
                )}
            </Text>
        </Flex>
    )
}
